export default "__VITE_ASSET__BeRzBTlk__"